package app.nestbridge.feature.invitations.service

import app.nestbridge.domain.identity.usecase.GetCurrentUserUseCase
import app.nestbridge.feature.careteam.model.CareTeamMember
import app.nestbridge.feature.careteam.model.TeamRelationshipRole
import app.nestbridge.feature.careteam.service.CareTeamService
import me.tatarka.inject.annotations.Inject
import software.amazon.lastmile.kotlin.inject.anvil.AppScope
import software.amazon.lastmile.kotlin.inject.anvil.ContributesBinding
import software.amazon.lastmile.kotlin.inject.anvil.SingleIn

interface TeamMembershipUpdater {
    suspend fun addCurrentUserIfMissing(teamId: String, role: TeamRelationshipRole): Result<Unit>
}

@SingleIn(AppScope::class)
@ContributesBinding(AppScope::class, boundType = TeamMembershipUpdater::class)
@Inject
class DefaultTeamMembershipUpdater(
    private val careTeamService: CareTeamService,
    private val getCurrentUserUseCase: GetCurrentUserUseCase,
) : TeamMembershipUpdater {

    override suspend fun addCurrentUserIfMissing(teamId: String, role: TeamRelationshipRole): Result<Unit> =
        runCatching {
            val userId = getCurrentUserUseCase()?.id ?: return@runCatching
            val careTeam = careTeamService.get(teamId) ?: return@runCatching
            if (careTeam.members.any { it.userId == userId }) return@runCatching

            careTeamService.save(
                careTeam.copy(
                    members = careTeam.members + CareTeamMember(
                        userId = userId,
                        role = role,
                    ),
                ),
            )
        }
}
